import ReactImage from '../../ReactImage'
import ReactText from '../../ReactText'
import { ReactListProps } from '../types'

const ReactCFStaticList = (props: ReactListProps) => {
  const { icon, altIcon, cfListItems } = props
  const hasBulletIcon = icon || altIcon

  return (
    <div className='bullet-list' data-testid={`react-cf-list-container`}>
      {cfListItems?.map((item: any, index: number) => {
        return (
          item && (
            <div className='bullet-list-item' key={`${item}${index}`} data-testid={`react-cf-list`}>
              {hasBulletIcon && (
                <ReactImage
                  src={icon}
                  imgCss={`bullet-icon ${icon && 'background-none'}`}
                  ariaLabel='bullet-icon'
                  alt={altIcon}
                  asIcon
                ></ReactImage>
              )}
              <ReactText className='bullet-text' text={item} isParsed />
            </div>
          )
        )
      })}
    </div>
  )
}
export default ReactCFStaticList
